import { IDeleteConfigPagamentoUseCase } from "../../../presentation/useCases/delete/delete_config_pagamento_use_case";
import {  ITerceirizacaoRepository } from "../../repositories/terceirizacao_repository";

// DeleteConfigPagamentoUseCase

export class DeleteConfigPagamentoUseCase implements IDeleteConfigPagamentoUseCase {
  constructor(private readonly repository: ITerceirizacaoRepository) {}

  async deleteConfigPagamento(idPgtoMedicao: number): Promise<void> {
    await this.repository.deleteConfigPagamento(idPgtoMedicao);
  }
}
